<template>
  <div class="customcheckerboard-almost-done">

    <div class="row text-center">

      <div class="colums small-8 medium-6 small-centered">
        <h3 class="customcheckerboard-almost-done-title" >{{ translations.customCheckerboardAlmostDoneTitle }}</h3>
      </div>
      <div class="colums small-8 medium-7 small-centered">
        <p class="customcheckerboard-almost-done-text">{{ subtitleText }}</p>
      </div>

      <create-new-checkerboard></create-new-checkerboard>

      <continue-same-checkerboard></continue-same-checkerboard>

      <div class="customcheckerboard-almost-done-linebreak text-center">
        <span class="customcheckerboard-almost-done-linebreak-line"></span>
        <span class="customcheckerboard-almost-done-linebreak-text">{{ translations.ugcInterModalOR }}</span>
      </div>
      <div class="customcheckerboard-almost-done-wrapper colums small-8 medium-7 small-centered">
        <p class="customcheckerboard-almost-done-text">{{ translations.customCheckerboardAlmostDoneDescr }}</p>
      </div>
      <finish-almost-done></finish-almost-done>
    </div>

  </div>
</template>

<script>

import continueSameCheckerboard from './ContinueSameCheckerboard';
import createNewCheckerboard from './CreateNewCheckerboard';
import finishAlmostDone from './FinishAlmostDone';

export default {
  name: 'checkerboardAlmostDone',
  components: {
    continueSameCheckerboard,
    createNewCheckerboard,
    finishAlmostDone
  },
  props: {
    canvasLoaded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      subtitleText : "",
    }
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    }
  },
  watch: {
    /**
     * This watch is useful when the warp view is skipped.
     * It means the canvas is not loaded when the user
     * clicks next. The init function inside created method won't be called
     * since when the component is rendered from size selector view
     * the canvas is not loaded yet. In a regular flow, the prop will be true
     * when the component is created, it means the init function in created
     * method will be executed.
     */
    canvasLoaded: function(newValue) {
      if (newValue) {
        this.init();
      }
    }
  },
  methods: {
    /**
     * @function resetFlowSecondComponent
     * Reset the flow for the follow use cases:
     * When the user goes back from createNewCheckerboard, it resets the navigation views and
     * removes the second component from components checkboard store.
     * When the user goes back from continueSameCheckerboard, it removes the second component
     * from components checkboard store.
     * Set canvas config using the active component.
     */
    resetFlowSecondComponent() {
      const { navigation: { views, activeViewIndex }, components }  = this.$store.state.customCheckerboard;
      const { activeComponent: activeUGCComponent } = this.$store.state.legacyNavigation;
      const nextComponent = this.$store.getters['customCheckerboard/getNextUGCComponent'];
      this.subtitleText = this.translations[`almostDoneCustomCheckerboard${nextComponent}`];
      // When the user has selected crete new checkerboard and goes back.
      // The views should be reseted
      if ( views.filter(val => val === 'checkerboardColorSelector' ).length > 1 ) {
        views.splice(activeViewIndex + 1, views.findIndex(view => view === 'checkerboardAlmostDone'));
        this.$store.commit("customCheckerboard/SET_VIEWS", views);
        this.$store.commit('customCheckerboard/SET_UPLOADED_IMAGE_DATA', {
          id: components[activeUGCComponent].ugc.original_image.image_id,
          url: components[activeUGCComponent].ugc.original_image.image_url
        });
      }
      if (Object.keys(components).length > 1) {
        // The component only should be removed in the new flow.
        // If it is edit flow, first it needs to be sure that the second component
        // doesn't have customcheckerboard applied.
        if (!this.$store.state.recipe.recipe_v2.components[nextComponent].toolkit_options) {
          this.$store.commit('customCheckerboard/REMOVE_COMPONENT_CONFIG', nextComponent);
        }
        this.$store.commit('customCheckerboard/SET_CANVAS_CONFIG', components[activeUGCComponent].canvasConfig);
        this.$emit('generateCanvas');
        this.$store.commit('customCheckerboard/SET_SECOND_VIEW', false);
      } else {
        this.$store.commit('customCheckerboard/SET_CANVAS_CONFIG', components[activeUGCComponent].canvasConfig);
      }
      this.$store.commit('customCheckerboard/SET_ACTIVE_UGC_COMPONENT', activeUGCComponent);
    },
    init() {
      this.$store.commit("customCheckerboard/SET_ENABLE_CONTROLS", true);
      this.resetFlowSecondComponent();
    }
  },
  created() {
    if (this.$props.canvasLoaded) {
      this.init();
    }
  }
}
</script>
